import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { ConfiguracoesProjeto, GenericHttpService, ParametrosService, UnidadeFederacaoModel } from '..';

@Injectable()
export class UnidadeFederacaoService {
  public _urlBase: string;
  public configuracao: ConfiguracoesProjeto;

  public ufs: UnidadeFederacaoModel[];
  public ufsChange = new Subject<UnidadeFederacaoModel[]>();
  public ufsErro = '';

  constructor(
    private readonly genericHttpService: GenericHttpService<UnidadeFederacaoModel>,
    private readonly parametrosService: ParametrosService
  ) {}

  get urlBase() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'unidade-federacao/';

    return this._urlBase;
  }

  getUfs() {
    const api = `listagem`;

    this.genericHttpService.getById(this.urlBase + api).subscribe(
      (data: any) => {
        this.ufs = <UnidadeFederacaoModel[]>data;
        this.ufsErro = '';
        this.ufsChange.next(this.ufs.slice());
      },
      (error: any) => {
        this.ufs = [];
        this.ufsErro = error;
        this.ufsChange.next(this.ufs.slice());
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/unidade-federacao.service.ts